var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showButton
    ? _c(
        "a",
        {
          attrs: { href: "#" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.completeLecture()
            },
          },
        },
        [
          _vm.size === "lg"
            ? _c("span", { staticClass: "px-4" }, [
                _vm._v(_vm._s(_vm.buttonText)),
              ])
            : _c("i", { staticClass: "fas fa-forward" }),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }